import { createFileRoute } from "@tanstack/react-router";
import { AffiliateLoginForm } from "components/Forms/AffiliateLoginForm/AffiliateLoginForm.tsx";
import { AuthLink } from "components/UI/AuthLink/AuthLink.tsx";
import { AuthPageContainer } from "components/UI/AuthPageContainer/AuthPageContainer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";


export const Route = createFileRoute("/$tenantSlug/auth/_layout/login/")({
    component: LoginPage,
});

function LoginPage() {
    const { t: tAuth } = usePaldockTranslation("auth.login");
    const { tenantSlug } = Route.useParams();

    return (
        <AuthPageContainer title={tAuth("title")}>
            <AffiliateLoginForm tenantSlug={tenantSlug} />
            <div className="flex justify-center mt-4 text-md text-black">
                {tAuth("messages.no_account")}{" "}
                <AuthLink to="/$tenantSlug/auth/registration" params={{ tenantSlug }} className="ml-1">
                    {tAuth("links.register")}
                </AuthLink>
            </div>
        </AuthPageContainer>
    );
}
